import httpService, { ErrorData } from "./HttpService";
import { BaseResponse, RecordResponse } from "./responses/BaseResponse";

export interface TimeResponse extends RecordResponse<number> {

}

export function getTime() : Promise<TimeResponse | ErrorData> {
  return httpService.get("/time");
}

const utils = {
  getTime,
};

export default utils;